import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/user.png")